import templateUrl from './social-share.html';
import filter from 'lodash/filter';
import head from 'lodash/head';

export const socialShareComponent = {
    templateUrl,

    controller: class SocialShareComponent {
        constructor($window, $timeout, SocialShareService) {
            'ngInject';

            this.$window = $window;
            this.$timeout = $timeout;
            this.socialShareService = SocialShareService;
        }

        $onInit() {
            this.showSocialShareOptions = false;
            this.showFacebookShareButton = false;
            this.shareUrl = this.$window.location.href;
            this._getSocialShareAppIds();
        }

        showHideSocialShareOptions() {
            this.showSocialShareOptions = !this.showSocialShareOptions;
        }

        openFb() {
            FB.ui({
                method: 'feed',
                display: 'popup',
                link: this.shareUrl
            }, function (response) { });
        }

        _getSocialShareAppIds() {
            this.socialShareService.getSocialShareAppIds()
                .then(appIdsDetails => {
                    const facebookShareApp = head(filter(appIdsDetails, ({name}) => name === 'Facebook'));
                    this.showFacebookShareButton = facebookShareApp.appId ? true : false;
                    this.showFacebookShareButton ? this._onInitFacebookSharing(facebookShareApp.appId) : true;
                });
        }

        _onInitFacebookSharing(appId) {
            FB.init({
                appId: appId,
                status: true,
                xfbml: true,
                cookie: true
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/common/components/social-share/social-share.component.js